import { useTranslation } from "@coworker/locales";
import React, { useState, useCallback, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { HFBList } from "./HFBList";
import { DivisionComponent } from "../../InputPopup/UserFiltersRow/Divisions/DivisionComponent";
import { useStoreId } from "../../../core/auth/useLoggedInUser";
import FixaSearch from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import styles from "@coworker/apprestructured/src/shared/styles/common-styles.module.css";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";

const SearchContainer = styled("div")`
  padding: 24px 16px;
  border-bottom: 1px solid var(--grey200);
`;

interface PopupProps {
  openAreaSearchListPopup: boolean;
  setOpenAreaSearchListPopup: React.Dispatch<SetStateAction<boolean>>;
  onSubmit: (area: string | { type: string; item: string }) => void;
  isAcesAndKing: boolean;
  area: string;
  setArea: Dispatch<SetStateAction<string>>;
}

export function AreaSearchListModal({
  onSubmit,
  isAcesAndKing,
  area,
  setArea,
  openAreaSearchListPopup,
  setOpenAreaSearchListPopup,
}: PopupProps) {
  const [searchValue, setSearchValue] = useState<string>();
  const enableDivisionsArea = false;
  const store_id = useStoreId();

  const { t } = useTranslation();

  const onSelectedArea = useCallback(
    (area: string | { type: string; item: string }) => {
      const areaValue = typeof area === "string" ? area : area.item;
      onSubmit(areaValue);
    },
    [onSubmit]
  );

  return (
    <FixaModal
      visible={openAreaSearchListPopup}
      handleCloseBtn={() => {
        setOpenAreaSearchListPopup(false);
      }}
    >
      <FixaSheets
        labelledById="testbuy-area-selection-list-modal-header"
        size="small"
        className={styles[""] || ""}
        header={
          <FixaModalHeader
            id="testbuy-area-selection-list-modal-header"
            className={styles["modal-header-border"] || ""}
            title={t("location3String")}
          />
        }
        footer={null}
      >
        <div data-testid="number-of-articles-container">
          {enableDivisionsArea ? (
            <DivisionComponent storeId={store_id} setChecked={onSelectedArea} />
          ) : (
            <>
              <SearchContainer>
                <FixaSearch
                  data-testid="search-input"
                  id="areaInput"
                  value={searchValue ?? ""}
                  placeholder={t("searchBasicString")}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onClear={() => setSearchValue("")}
                />
              </SearchContainer>
              <HFBList
                filter={searchValue}
                onSelect={onSelectedArea}
                isAcesAndKing={isAcesAndKing}
                area={area}
                setArea={setArea}
              />
            </>
          )}
        </div>
      </FixaSheets>
    </FixaModal>
  );
}
